import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { StepperModule } from 'primeng/stepper';

import { ExpensesRoutingModule } from './expenses-routing.module';
import { GastosComponent } from './gastos/gastos.component';
import { ResourcesModule } from '../resources/resources.module';
import { ToastModule } from 'primeng/toast';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';



@NgModule({
  declarations: [GastosComponent],
  imports: [
    CommonModule,
    ExpensesRoutingModule,
    ResourcesModule,
    FormsModule, ReactiveFormsModule,
    DropdownModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    ToastModule,
    StepperModule,
    DatePickerModule,
    SelectModule
  ]
})
export class ExpensesModule { }
